import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SidenavMenu } from 'src/app/core/interfaces/UI/i-menu';
import { AuthService } from 'src/app/core/services/api/auth.service';

@Component({
  selector: 'app-sidenav-menu',
  templateUrl: './sidenav-menu.component.html',
  styleUrls: ['./sidenav-menu.component.scss']
})
export class SidenavMenuComponent implements OnInit {

  
  @Input('menuItems') menuItems!: SidenavMenu[];
  @Input('menuParentId') menuParentId: any;

  constructor(
    public authService: AuthService,
    private router: Router,
    // private sectionService :SectionService
    ) { }

  ngOnInit(): void {
   
  }

  
  onClick(item: SidenavMenu) {
    
    this.toggleMenuItem(item.id);
    this.closeOtherSubMenus(this.menuItems, item.id);
    // this.sectionService.nameSection = item.name;
    // HACEMOS LOGOUT
    if (item.name === 'Salir') {
      this.authService.logout();
    }
    if ((item.parentId !== 0) || (item.parentId === 0 && item.submenu && item.submenu.length === 0)) {
      this.router.navigate([`/${item.url}`]);
    }
  }

  toggleMenuItem(menuId: number) {
    let menuItem = document.getElementById('menu-item-' + menuId);
    let subMenu = document.getElementById('sub-menu-' + menuId);
    if (subMenu) {
      if (subMenu.classList.contains('show')) {
        subMenu.classList.remove('show');
        menuItem?.classList.remove('expanded');
      }
      else {
        subMenu.classList.add('show');
        menuItem?.classList.add('expanded');
      }
    }
  }


  closeOtherSubMenus(menu: Array<SidenavMenu>, menuId: number) {
    let currentMenuItem = menu.filter(item => item.id == menuId)[0];
    menu.forEach(item => {
      if ((item.id != menuId && item.parentId == currentMenuItem.parentId) || (currentMenuItem.parentId == 0 && item.id != menuId)) {
        let subMenu = document.getElementById('sub-menu-' + item.id);
        let menuItem = document.getElementById('menu-item-' + item.id);
        if (subMenu) {
          if (subMenu.classList.contains('show')) {
            subMenu.classList.remove('show');
            menuItem?.classList.remove('expanded');
          }
        }
      }
    });
  }
}
